const navigationReducer = (
    state = {
        scrollPositions: {
            explore: {
                feed: 0,
                heatmap: 0
            },
            news: {
                main: 0
            },
            library: {
                main: 0
            },
            profile: {
                main: 0
            },
            // Add more pages as needed
        },
        currentPage: 'explore',
        currentTab: 'feed'
    },
    action
) => {
    switch (action.type) {
        case 'SAVE_SCROLL_POSITION':
            return {
                ...state,
                scrollPositions: {
                    ...state.scrollPositions,
                    [action.payload.page]: {
                        ...state.scrollPositions[action.payload.page],
                        [action.payload.tab || 'main']: action.payload.position
                    }
                }
            };
            
        case 'SET_CURRENT_PAGE':
            return {
                ...state,
                currentPage: action.payload
            };
            
        case 'SET_CURRENT_TAB':
            return {
                ...state,
                currentTab: action.payload
            };
            
        case 'RESTORE_SCROLL_POSITION':
            return {
                ...state,
                currentPage: action.payload.page,
                currentTab: action.payload.tab || 'main'
            };
        case 'STOP_SCROLLING':
            return {
                ...state,
                stopScrolling: action.payload
            };
        case 'SET_HIDE_BOTTOM_NAV':
            return {
                ...state,
                hideBottomNav: action.payload
            };
        default:
            return state;
    }
};

export default navigationReducer; 